module.exports = __webpack_public_path__ + "img/icon_potatoes.b83a87ae.svg";